
import { Vue, Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';

import ProductOrdersPendingModule, {
  EXCLUDE_TEST_JOBS_FILTER,
} from '../../store/product-orders-pending.module';

@Component
export default class ProductOrdersPendingCount extends Vue {
  // Computed
  get store(): ProductOrdersPendingModule {
    return getModule(ProductOrdersPendingModule, this.$store);
  }

  created() {
    // Exclude test jobs so the nav badge matches the default list view
    // (which hides test jobs unless "Include test jobs" is checked). See GID-2236.
    this.store.ITEMS_FETCH({
      query: {
        page: 1,
        limit: 1,
      },
      search: { $and: [EXCLUDE_TEST_JOBS_FILTER] },
    });
  }

  get count() {
    return this.store.pagination.totalRows;
  }
}
